import {
  config
} from "../../config/config";
class Baidu {
  constructor() {
    this.scriptUrl = "https://b.bdstatic.com/searchbox/icms/searchbox/js/swan-2.0.12.js"
    this.name = "baidu"
  }
  navigateTo(src) {
    //TODO后期需要修改
    swan.webView.navigateTo({
      url: '/' + src
    });
  }
  navigateBack(){
    swan.webView.navigateBack({})
  }
  reLaunchTo(src) {
    swan.webView.reLaunch({
        url:'/'+src
    });
}
redirectTo(src) {
  swan.webView.redirectTo({
      url:'/'+src
  });
}
gopay(path,data){
  let baidupath = 'pages/api/api';
  let str = ``;
  Object.keys(data).forEach(item=>{
      if(typeof data[item] === 'object'){
        let tmp = JSON.stringify(data[item])
        str+=`${item}=${tmp}&`;
      } else if(item === 'rsaSign'){
        let tmp = encodeURIComponent(data[item])
        str+=`${item}=${tmp}&`;
      }
      else{
        str+=`${item}=${data[item]}&`;
      }
  })
  str = str.slice(0,-1);
  baidupath+=`?${str}`;
  this.redirectTo(baidupath);
}
takecamera(platform,spec_id,openid){
  this.navigateTo(`pages/api/api?api=takephoto&type=camera&spec_id=${spec_id}&openid=${openid}`);
  return Promise.reject("这是百度处理方式");
}
takephoto(platform,spec_id,openid){
  this.navigateTo(`pages/api/api?api=takephoto&type=album&spec_id=${spec_id}&openid=${openid}`);
  return Promise.reject("这是百度处理方式");
}
chooseImage(type,platform,spec_id,openid) {
  console.log(platform)
  return new Promise((resolve,reject) => {
    swan.chooseImage({
      count: 1,
      sizeType: ['original'],
      sourceType:[type],
      success: res => {
        let tempFilePaths = res.tempFilePaths;
        console.log(swan)
        swan.uploadFile({
          url: `${config.serverBaseUrl3}/union_applet/union_applet_make_photo`,
          header:{
            platform:platform,
            openid:openid
          },
          filePath: tempFilePaths[0],
          name: 'file',
          formData: {
            spec_id: spec_id
          },
          success: res => {
            resolve(res.data);
          }
        })
      }
    })
  })
}
  makePhoneCall(tel) {
    swan.makePhoneCall({
      phoneNumber: tel,
      fail: err => {
        console.log(err)
      }
    });
  }
  qiyu(){
    location.href="https://wxlqkjyxgs.qiyukf.com/client?k=90d344f50c3d6ac29e60360bae8e8639&wp=1&robotShuntSwitch=1&robotId=3425033&sid=3889771"
  }
  //判断当前环境是否是百度小程序
  isme() {
    let userAgent = window.navigator.userAgent
    return !!window['__swanjs_environment'] ||
      /baidu/i.test(userAgent) ||
      /swan/.test(userAgent)
  }
  savePhone(orderId,platform) {
    this.navigateTo(`pages/api/api?description=savePhone&orderId=${orderId}&platform=${platform}`);
  }
}
export default new Baidu()